import { createNamedOptionChoice, fetchNamedOptionChoices } from "features/settings/api/namedOptionResource";
import { surgeonResource } from "features/settings/constants/healthSelectionResources";

export const fetchSurgeons = async (search: string) => {
  return fetchNamedOptionChoices(surgeonResource, search);
};

export const createSurgeon = async (name: string) => {
  return createNamedOptionChoice(surgeonResource, name);
};
